// extracted by mini-css-extract-plugin
export default {"image-info-content":"index_image-info-content__GEjDz","mn-ins-more-btn":"index_mn-ins-more-btn__i2S0v"};